var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":"Riddles Average Duration (m:s)","sublabel":"What riddles have the highest average watched duration?","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"value-formatter":_vm.formatDuration}})
}
var staticRenderFns = []

export { render, staticRenderFns }